import { useLayoutEffect } from "react";
import Datalayer from "../libs/vendors/data-layer";
import { ENV } from "../constants/env";
export const useDatalayerInit = () => {
    useLayoutEffect(() => {
        setTimeout(() => {
            Datalayer.init();
        }, ENV.LANDING.VENDORS_DELAY);
    }, []);
};
